
define('text!modules/admin/creatives/templates/components-list.html',[],function () { return '<creative-admin-component-list id="creative-component-list" fitparent unresolved></creative-admin-component-list>\n';});

